module.exports = __webpack_public_path__ + "img/log.b991fc79.png";